import { BindingUtil, TLBaseBinding, Vec } from "tldraw"
import { CustomDrawShape } from "../../shared/CustomDrawShape"
import { LDGeoShape } from "../../shared/LDGeoShape"
import { densifyLine } from "../tools/CustomNudge"
import { getGeoShapePath } from "./draw/getGeoShapePath"
import { parseSVGPath1 } from "../pages/TestSvg"
import { LDShape } from "../../shared/LDShape"
import { LDPage } from "../../shared/LDPage"

export type FillBinding = TLBaseBinding<"fill", { x: number; y: number }[]>

export class FillBindingUtil extends BindingUtil<FillBinding> {
  static override type = "fill" as const

  override getDefaultProps() {
    return [{ x: 0.5, y: 0.5 }]
  }

  override onAfterChangeToShape({ binding }: { binding: FillBinding }) {
    //console.log('binding', binding)
    const shape = this.editor.getShape(binding.toId)! as
      | CustomDrawShape
      | LDGeoShape

    const page = this.editor.getPage(
      LDShape.getSourcePageId(this.editor, shape),
    ) as LDPage

    // the from shape will always be a fill (because it's a fill binding)
    const fromShape = this.editor.getShape(binding.fromId)! as LDGeoShape & {
      props: { fill: true }
    }
    // const shapeUtil = this.editor.getShapeUtil(shape)
    // const shapeGeometry = shapeUtil.getGeometry(shape)
    // const shapeVertices = shapeGeometry.vertices

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // const translatedSegments = shape.props.segments[0].points.map(
    //   (point: any) => {
    //     const translatedPoint = new Vec(point.x, point.y).add({
    //       x: shape.x,
    //       y: shape.y,
    //     })
    //     return { x: translatedPoint.x, y: translatedPoint.y }
    //   },
    // )
    console.log("rotation", shape.rotation)

    if (!this.editor.getSelectedShapeIds().includes(binding.fromId)) {
      if (shape.type === "custom-draw") {
        this.editor.updateShape({
          id: binding.fromId,
          x: shape.x,
          y: shape.y,
          type: "custom-draw",
          rotation: shape.rotation,

          props: {
            segments: shape.props.segments,

            scale: 1,
          },
        })
      } else {
        const points = densifyLine(
          parseSVGPath1(
            getGeoShapePath(shape).toDrawD({
              strokeWidth: 1,
              passes: 1,
              randomSeed: shape.id,
              offset: 0,
              roundness: 0,
              // roundness: Expr.evaluate(
              //   shape.props.parameterValues.roundness,
              //   page.meta.parameterValues,
              // ),
            }),
          )[0].map((point) => {
            const translated = new Vec(point[0], point[1]).add({
              x: shape.x,
              y: shape.y,
            })
            return { x: translated.x, y: translated.y, z: 1 }
          }),
        )
        // densifyLine(
        //   getGeoShapePath(shape)
        //     .toGeometry()
        //     .vertices.map((point) => {
        //       const translatedPoint = new Vec(point.x, point.y).add({
        //         x: shape.x,
        //         y: shape.y,
        //       })
        //       return { x: translatedPoint.x, y: translatedPoint.y, z: 1 }
        //     }),
        // )
        this.editor.updateShape<LDGeoShape>({
          id: binding.fromId,
          x: shape.x,
          y: shape.y,
          type: "custom-geo",
          rotation: shape.rotation,

          props: {
            fill: true,
            parameterValues: {
              ...shape.props.parameterValues,
              fillColor: fromShape.props.parameterValues.fillColor,
              roundness: shape.props.parameterValues.roundness,
            },
          },
        })
      }
    }

    // move the sticker so it stays attached to the to shape
  }
}
